import React from 'react';
import {Box, Title, Stack, Anchor, Group} from '@mantine/core';
import {SocialLink} from '@/types/social_links';
import {extractUsername, getPlatformIcon, buildSocialUrl} from '@/utils/social_links_helpers';

type SocialLinksProps = {
    links: SocialLink[];
    isEditMode?: boolean;
};

export const SocialLinks = ({links, isEditMode}: SocialLinksProps) => {
    const hasSocialLinks = links.length > 0;

    if (!hasSocialLinks && !isEditMode) {
        return null;
    }

    const sortedLinks = [...links].sort((a, b) => a.order - b.order);

    return (
        <Box>
            <Title order={3} size="h5" mb="xs">
                Social Links
            </Title>
            <Stack gap="xs">
                {sortedLinks.map((link) => {
                    const Icon = getPlatformIcon(link.type);
                    const fullUrl = buildSocialUrl(link.url, link.type);
                    const displayText = extractUsername(fullUrl, link.type);

                    return (
                        <Group gap="xs" key={link.id}>
                            <Icon size={16} />
                            <Anchor
                                href={fullUrl}
                                target="_blank"
                                c="blue"
                                size="sm"
                            >
                                {displayText}
                            </Anchor>
                        </Group>
                    );
                })}
            </Stack>
        </Box>
    );
};
